export default store => next => (action) => {
    if (typeof action !== 'function') {
        next({ ...action, getState: store.getState });
    } else {
        // this let's thunks pass through
        next(action);
    }
};



// WEBPACK FOOTER //
// ./src/middleware/exposeGetState.js